import { render, staticRenderFns } from "./ModalAdicionarArquivosOs.vue?vue&type=template&id=6e760db1&"
import script from "./ModalAdicionarArquivosOs.vue?vue&type=script&lang=js&"
export * from "./ModalAdicionarArquivosOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports